module.exports = __webpack_public_path__ + "img/training-dancing.23ef5905.svg";